import { useEffect } from "react";

function CookieConsent() {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "cookieyes";
    script.type = "text/javascript";
    script.src = "https://cdn-cookieyes.com/client_data/d3f5489549d73ded10c4f856/script.js";
    document.head.appendChild(script);
  }, []);

  return null;
}

export default CookieConsent;
